import learndleWord from './learndleWord';

// Main game service object
export const gameService = {
  learndleWord,
};

// Export individual game modules for convenience
export { learndleWord };

// Export the main service as default
export default gameService;
